declare var THREE: any;

export class Hole {
  public readonly id: string;
  private _start;
  private _end;

  constructor(
    start,
    end
  ) {
    this.id = THREE.Math.generateUUID();
    this._start = start;
    this._end = end;
  }

  get start() {
    return this._start.clone();
  }

  get end() {
    return this._end.clone();
  }

  get direction() {
    return this.end
      .clone()
      .sub(this.start)
      .normalize();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/railing/Hole.ts